/* eslint-disable eqeqeq */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormConfiguracao from '../../../components/configuracao/form-configuracao';
import FormGrupoImposto from '../../../components/grupo-imposto/form-grupo-imposto';
import FormCertificado from '../../../components/configuracao/form-certificado';
import Grid from '@material-ui/core/Grid';
import consultaApi from '../../../services/consultaApi';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';
import theme from '../../layout/theme';

const tema = theme();

const useQontoStepIconStyles = makeStyles((theme) => ({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: '#784af4',
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#784af4',
        zIndex: 1,
        fontSize: 18,
    },
}));

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ?
                <Check className={classes.completed} />
                : <div className={classes.circle} />}
        </div>
    );
}

QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundImage:
                tema.theme.linearGradientPrimary,
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                tema.theme.linearGradientSecondary,
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundImage:
            tema.theme.linearGradientPrimary,
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundImage:
            tema.theme.linearGradientSecondary,
    },
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
        1: <SettingsIcon />,
        2: <GroupAddIcon />,
        3: <VideoLabelIcon />,
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    footerControl: {
        position: 'fixed',
        width: '100%',
        zIndex: 100,
        backgroundColor: "#f1f1f1",
        bottom: 0
    },
    footerButtonsControl: {
        padding: 5
    },
    botaoVoltar: {
        color: '#FFF',
        backgroundColor: tema.theme.secondary,
        padding: theme.spacing(1),
        width: '100%',
    },
    botaoAvancar: {
        width: '100%',
        padding: theme.spacing(1),
    }
}));

function getSteps() {
    return ['Grupo Imposto', 'Configurações gerais', 'Certificado'];
}



export default function PrimeiroAcesso(props) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const steps = getSteps();
    const [grupoImposto, setGrupoImposto] = useState(null);

    const grupoImpostoRef = useRef(null);
    const configuracaoRef = useRef(null);
    const certificdoRef = useRef(null);

    const history = useHistory();

    function getStepContent(step) {
        switch (step) {
            case 0:
                return <>
                    {grupoImposto ? <FormGrupoImposto
                        ref={grupoImpostoRef}
                        grupoImposto={grupoImposto}
                        primeiroAcesso
                    /> : <CircularProgress />}
                </>;
            case 1:
                return <FormConfiguracao
                    ref={configuracaoRef}
                    primeiroAcesso
                />;
            case 2:
                return <FormCertificado
                    ref={certificdoRef}
                    primeiroAcesso
                />;
            default:
                return 'Recarregue a página por favor';
        }
    }

    const handleNext = async () => {
        if (activeStep == 0) {
            let retornoSalvar = await grupoImpostoRef.current.salvarGrupoImposto();
            if (retornoSalvar) {
                setGrupoImposto(null);
                setActiveStep(activeStep + 1);
            }
        } else {
            if (activeStep == 1) {
                let retornoSalvar = await configuracaoRef.current.salvarConfiguracoes();
                if (retornoSalvar) {
                    setActiveStep(activeStep + 1);
                }
            } else {
                if (activeStep == 2) {
                    let retornoSalvar = await certificdoRef.current.salvarCertificado();
                    if (retornoSalvar) {
                        let dadosEnvio = {
                            PROCNAME: 'WEBSITE_CONCLUI_FIRST_ACESSO',
                        };

                        await consultaApi(dadosEnvio);

                        localStorage.setItem('PRIMEIRO_ACESSO', 0);
                        setActiveStep(activeStep + 1);
                    }
                }
            }
        }
    }

    async function carregarGrupoImposto() {
        let dadosEnvio = {
            PROCNAME: 'WEBSITE_TIMPOSTO_GRUPO_BYID',
            PCCDTAXGRUPO: 1
        };

        const resposta = await consultaApi(dadosEnvio);
        setGrupoImposto(resposta.data.DATASET[0]);
    }

    useEffect(() => {
        carregarGrupoImposto();
    }, [])

    useEffect(() => {
        carregarGrupoImposto();
    }, [activeStep]);

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        history.push({
            pathname: '/home',
            iniciarTour: true
        });
    };

    return (
        <div className={classes.root}>

            <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel
                            StepIconComponent={ColorlibStepIcon}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div>
                {activeStep === steps.length ? (
                    handleReset()
                ) : (
                    <div>
                        <Typography className={classes.instructions}>
                            {getStepContent(activeStep)}
                        </Typography>
                        <div className={classes.footerControl}>
                            <Grid container>
                                <Grid item xs={6} className={classes.footerButtonsControl}>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.botaoVoltar}
                                        fullWidth
                                    >
                                        Voltar
                                    </Button>
                                </Grid>
                                <Grid item xs={6} className={classes.footerButtonsControl}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        className={classes.botaoAvancar}
                                        fullWidth
                                    >
                                        {activeStep === steps.length - 1 ?
                                            'Finalizar'
                                            : 'Avançar'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}